import { createSelector } from 'reselect';
import { i18n } from 'invision-core';
import { FormattedCaseCategoryCodeSelector, FormattedCasePriorityCodeSelector, FormattedCaseSeverityCodeSelector, FormattedDisputeInvoiceCaseTypesSelector } from '../../../reducers/selectors/customer.cases.selectors';
import LocaleKeys from '../../../locales/keys';
export var CasePriorityOptionsSelector = createSelector([FormattedCasePriorityCodeSelector], function (priorities) {
  var selectOption = {
    text: i18n.translate(LocaleKeys.ORDER_DETAILS.CREDIT.SELECT),
    value: undefined // must be undefined for required validation to work
  };
  return [selectOption].concat(priorities);
});
export var CaseSeverityOptionsSelector = createSelector([FormattedCaseSeverityCodeSelector], function (severities) {
  var selectOption = {
    text: i18n.translate(LocaleKeys.ORDER_DETAILS.CREDIT.SELECT),
    value: undefined // must be undefined for required validation to work
  };
  return [selectOption].concat(severities);
});
export var CaseCategoryOptionsSelector = createSelector([FormattedCaseCategoryCodeSelector], function (categories) {
  var selectOption = {
    text: i18n.translate(LocaleKeys.ORDER_DETAILS.CREDIT.SELECT),
    value: undefined // must be undefined for required validation to work
  };
  return [selectOption].concat(categories);
});
export var DisputeInvoiceCaseTypesOptionsSelector = createSelector([FormattedDisputeInvoiceCaseTypesSelector], function (categories) {
  var selectOption = {
    text: i18n.translate(LocaleKeys.ORDER_DETAILS.CREDIT.SELECT),
    value: undefined // must be undefined for required validation to work
  };
  return [selectOption].concat(categories);
});